import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=1d90da01&lang=html&"
import script from "./DemoPage.vue?vue&type=script&lang=js&"
export * from "./DemoPage.vue?vue&type=script&lang=js&"
import style0 from "./DemoPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DemoPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports